import * as React from 'react';
import { PopupProvider } from 'modules/common/components/PopupContext';
import ToastProvider from 'modules/common/components/Toast';

const UXContextProviders: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ToastProvider clearOnPageChange>
    <PopupProvider>{children}</PopupProvider>
  </ToastProvider>
);

export default UXContextProviders;
